import {useContext} from 'react'
import {RuntimeContext} from '../../../../../../common/RuntimeContext';

const CompanyAdminResources = () => {

    const {pathsWeb} = useContext(RuntimeContext);
    
    const resourceUrl = pathsWeb.adminResourcesUrl;
    
    return (
    <div className='mb-5'>
        {
            !resourceUrl ? 'No Admin Resource Available' : <iframe src={resourceUrl} width={'100%'} height={'600px'} />
        }
    </div>
)
}

export default CompanyAdminResources;